<template>
  <div class="editInformation">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit"
    >
      <div class="title">{{ $t.information.userInfo }}</div>
      <van-field :label="$t.information.avatar">
        <template #input>
          <van-uploader v-model="headImg" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>
      <van-field :label="$t.information.card">
        <template #input>
          <van-image
            width="80"
            height="80"
            :src="qrCode"
            @click="qrcodePreview(qrCode)"
          />
        </template>
        <template #button>
          <van-button
            size="small"
            type="info"
            native-type="button"
            @click="onSave"
            v-if="isApp && qrCode"
            >{{ $t.meta.saveToAlbum }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="form.UserName"
        :label="$t.information.userName"
        :name="$t.information.userName"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.Email"
        :label="$t.information.email"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.PhoneNumber"
        :label="$t.information.phone1"
        :name="$t.information.phone1"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.PhoneNumber2"
        :label="$t.information.phone2"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.FixedTelephone"
        :label="$t.information.fixedPhone"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.WechatNumber"
        :label="$t.information.wechat"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.QQNumber"
        :label="$t.information.qq"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.WhatsappNumber"
        :label="$t.information.whatsapp"
        :placeholder="$t.information.input"
      />
      <van-field
        v-model="form.Website"
        :label="$t.information.website"
        :placeholder="$t.information.input"
      />

      <div class="title">{{ $t.information.eCard }}</div>

      <van-field :label="$t.information.chinese" label-class="subTitle" readonly />

      <van-field
        v-model="form.UserPersonalInfoCn.Name"
        :label="$t.information.name"
        :placeholder="$t.information.input"
      />

      <van-field
        v-model="form.UserPersonalInfoCn.Department"
        :label="$t.information.department"
        :placeholder="$t.information.input"
      />

      <van-field
        v-model="form.UserPersonalInfoCn.Position"
        :label="$t.information.position"
        :placeholder="$t.information.input"
      />

      <van-field
        v-model="form.UserPersonalInfoCn.MailingAddress"
        :label="$t.information.mailingAddress"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoCn.IndividualResume"
        :label="$t.information.individualResume"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoCn.ServiceSectionIntroduction"
        :label="$t.information.serviceSectionIntroduction"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoCn.ProjectCase"
        :label="$t.information.projectCase"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoCn.PersonalSayings"
        :label="$t.information.personalSayings"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field :label="$t.information.english" label-class="subTitle" readonly />

      <van-field
        v-model="form.UserPersonalInfoEn.Name"
        :label="$t.information.name"
        :placeholder="$t.information.input"
      />

      <van-field
        v-model="form.UserPersonalInfoEn.Department"
        :label="$t.information.department"
        :placeholder="$t.information.input"
      />

      <van-field
        v-model="form.UserPersonalInfoEn.Position"
        :label="$t.information.position"
        :placeholder="$t.information.input"
      />

      <van-field
        v-model="form.UserPersonalInfoEn.MailingAddress"
        :label="$t.information.mailingAddress"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoEn.IndividualResume"
        :label="$t.information.individualResume"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoEn.ServiceSectionIntroduction"
        :label="$t.information.serviceSectionIntroduction"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoEn.ProjectCase"
        :label="$t.information.projectCase"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.UserPersonalInfoEn.PersonalSayings"
        :label="$t.information.personalSayings"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <div class="multi-table" v-if="form.UserFileList">
        <van-field name="stepper" :label="$t.information.filename">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.UserFileList.length"
              @minus="handleUserFileDel"
              @plus="handleUserFileAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.UserFileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No. {{ index + 1 }}</div>
            <div class="multi-table-btn" @click="handleUserFileDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.CustomName"
            :label="$t.information.customizeName"
            :placeholder="$t.information.input"
          />
          <van-field :label="$t.information.filename">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                native-type="button"
                v-if="item.FileAddress"
                >{{ $t.information.view }}</van-button
              >
              <van-uploader :after-read="afterRead2" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.information.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="tool-bar">
        <van-button block type="info" native-type="submit">{{
          $t.information.submit
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon, Image, Stepper, ImagePreview } from "vant";
import { isAPP } from "@/plugins/environment/type.js";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Image)
  .use(Stepper)
  .use(ImagePreview);

export default {
  name: "editInformation",
  data() {
    return {
      isApp: isAPP(),
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      headImg: [],
      qrCode: "",
      filesIndex: 0,
    };
  },
  created() {
    this.form.UserPersonalInfoCn = this.initInfo();
    this.form.UserPersonalInfoEn = this.initInfo();
    this.getUserInfo();
    this.getQrCode();
  },
  methods: {
    ...mapMutations([SET_AUTH]),
    onSave() {
      var element = document.createElement("img");
      element.setAttribute("src", this.qrCode);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.downloadImage, {
        element: element,
        successText: this.$t.meta.saveSuccess,
        failText: this.$t.meta.saveError,
      });
    },
    handleUserFileDelByIndex(index) {
      if (this.form.UserFileList.length > 0) {
        this.form.UserFileList.splice(index, 1);
      }
    },
    handleUserFileDel() {
      if (this.form.UserFileList.length > 0) {
        this.form.UserFileList.pop();
      }
    },
    handleUserFileAdd() {
      this.form.UserFileList.push({
        CustomName: "",
        FileAddress: "",
        FileAddress_sl: "",
      });
    },
    qrcodePreview(data) {
      ImagePreview({ images: [data], closeable: true, startPosition: 0 });
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getQrCode() {
      var param = { WebSiteUrl: "" };
      this.$api.myHome.userSharingQrCode(param).then((res) => {
        this.qrCode = "data:image/png;base64," + res.data;
      });
    },
    getUserInfo() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
        };
        this.$api.myHome
          .getUserInfo(param)
          .then((res) => {
            this.form = res.data;
            if (this.form.HeadImg) {
              this.headImg.push({ url: this.imgUrlFilter(this.form.HeadImg) });
            }
            this.form.UserFileList = res.data.UserFileList || [];
            this.SET_AUTH(res.data);
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    initInfo() {
      return {
        Name: "",
        Department: "",
        Position: "",
        MailingAddress: "",
        IndividualResume: "",
        ServiceSectionIntroduction: "",
        ProjectCase: "",
        PersonalSayings: "",
      };
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      this.$api.myHome
        .editUserInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.getUserInfo().then((success) => {
            if (success) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
            }
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.HeadImg = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.UserFileList[this.filesIndex].FileAddress = res.data;
          this.form.UserFileList[this.filesIndex].FileAddress_sl = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.editInformation {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .subTitle {
    color: #2c88c1 !important;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
